import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=d5716592&scoped=true"
var script = {}
import style0 from "./AboutView.vue?vue&type=style&index=0&id=d5716592&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5716592",
  null
  
)

export default component.exports